const TransactionStepper = ({ currentStep, totalSteps }) => {
  return (
    <div className="stepper mb-4">
      <div className="d-flex justify-content-between align-items-center">
        {[...Array(totalSteps)].map((_, index) => {
          const stepNumber = index + 1;
          return (
            <div key={stepNumber} className="d-flex flex-column align-items-center">
              <div className={`step-circle ${currentStep >= stepNumber ? 'active' : ''}`}>
                {stepNumber}
              </div>
              <small className={`mt-1 ${currentStep >= stepNumber ? 'fw-bold' : 'text-muted'}`}>
                {stepNumber === 1 ? 'Type' : stepNumber === 2 ? 'Détails' : 'Documents'}
              </small>
            </div>
          );
        })}
      </div>
      <div className="progress mt-2" style={{ height: '3px' }}>
        <div 
          className="progress-bar bg-primary" 
          style={{ width: `${(currentStep / totalSteps) * 100}%` }}
          role="progressbar"
        />
      </div>
    </div>
  );
};

export default TransactionStepper;